<template>
  <div class="not-found">
    <div class="not-found__content">
      <div class="not-found__content-info">
        <h1>404</h1>
        <p class="not-found__title">Страница не найдена</p>
        <p class="not-found__subtitle">
          Не переживайте: иногда, чтобы найти что-то особенное, нужно немного
          заблудиться. Давайте начнем сначала.
        </p>
        <CustomButton
          v-if="!isMobile"
          to="/"
          class="not-found__button"
          text="Вернуться на главную"
          >Вернуться на главную</CustomButton
        >
      </div>
      <div class="not-found__content-img">
        <img
          src="@/assets/images/compass.png"
          alt="Компас"
          class="not-found__compass"
        />
      </div>
      <CustomButton
        v-if="isMobile"
        to="/"
        class="not-found__button"
        text="Вернуться на главную"
        >Вернуться на главную</CustomButton
      >
    </div>
    <img
      src="@/assets/images/cloud.png"
      alt="Облако"
      class="not-found__cloud cloud-left"
    />
    <img
      src="@/assets/images/cloud.png"
      alt="Облако"
      class="not-found__cloud cloud-right"
    />
  </div>
</template>

<script>
import CustomButton from "@/components/CustomButton.vue";

export default {
  name: "NotFoundPage",
  components: { CustomButton },
  data() {
    return {
      isMobile: window.innerWidth <= 1024,
    };
  },
};
</script>

<style lang="scss" scoped>
.not-found {
  text-align: center;
  padding: 50px 20px;
  position: relative;
  height: 100vh;
  overflow: hidden;
  padding-top: 100px;
  &__content {
    padding-top: 100px;
    z-index: 2;
    position: relative;
    text-align: left;
    display: flex;
    align-items: center;
    width: 100%;
    gap: 120px;
    max-width: 1024px;
    margin: 0 auto;

    &-info {
      max-width: 540px;
    }
    &-img {
      width: 423px;
      height: 423px;
    }
  }

  h1 {
    @include coolvetica();
    font-size: 300px;
    font-style: normal;
    line-height: normal;
    color: $blue;
    margin: 0;
  }

  &__title {
    color: $black;
    @include manrope(600);
    font-size: 32px;
    font-style: normal;
    line-height: 130%; /* 41.6px */
    margin-bottom: 24px;
  }

  &__subtitle {
    color: $black;
    @include manrope(400);
    font-size: 24px;
    font-style: normal;
    line-height: 130%; /* 31.2px */

    margin-bottom: 48px;
  }

  &__button {
    background-color: $button-bgc-color;
    color: $white;
    font-size: 32px;
    border-radius: 20px;
  }

  &__compass {
    position: absolute;
    width: 423px;
    height: 423px;
    z-index: 1;
  }

  &__cloud {
    position: absolute;
    width: 467px;
    height: 242px;
    flex-shrink: 0;
    top: 15%;
    z-index: 0;
    opacity: 0.8;
    &.cloud-left {
      left: -10%;
    }

    &.cloud-right {
      right: -10%;
    }
  }
}

@media (max-width: 1600px) and (min-width: 1025px) {
  .not-found {
    text-align: center;
    padding: 50px 20px;
    position: relative;
    height: 100vh;
    overflow: hidden;
    padding-top: 150px;
    &__content {
      padding-top: 100px;
      z-index: 2;
      position: relative;
      text-align: left;
      display: flex;
      align-items: center;
      width: 100%;
      gap: 120px;
      max-width: 1024px;
      margin: 0 auto;

      &-info {
        max-width: 540px;
      }
      &-img {
        width: 423px;
        height: 423px;
        display: flex;
        align-items: center;
      }
    }

    h1 {
      font-size: 150px;
    }

    &__title {
      font-size: 24px;
      margin-bottom: 24px;
    }

    &__subtitle {
      color: $black;
      @include manrope(400);
      font-size: 18px;
      font-style: normal;
      line-height: 130%; /* 31.2px */

      margin-bottom: 48px;
    }

    &__button {
      background-color: $button-bgc-color;
      color: $white;
      font-size: 22px;
      border-radius: 8px;
      height: auto;
    }

    &__compass {
      position: absolute;
      width: 323px;
      height: auto;
      z-index: 1;
    }

    &__cloud {
      position: absolute;
      width: 367px;
      height: auto;
      flex-shrink: 0;
      top: 20%;
      z-index: 0;
      opacity: 0.8;
      &.cloud-left {
        left: -10%;
      }

      &.cloud-right {
        right: -10%;
      }
    }
  }
}
@media (max-width: 1024px) {
  .not-found {
    text-align: center;
    padding: 50px 20px;
    position: relative;
    height: auto;
    overflow: hidden;

    &__content {
      padding-top: 200px;
      z-index: 2;
      position: relative;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      gap: 20px;
      max-width: 1024px;
      margin: 0 auto;

      &-info {
        max-width: 540px;
      }
      &-img {
        width: 250px;
        height: 250px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
    }

    h1 {
      font-size: 100px;
    }

    &__title {
      font-size: 24px;
      margin-bottom: 24px;
    }

    &__subtitle {
      font-size: 20px;
      margin-bottom: 28px;
    }

    &__button {
      font-size: 20px; /* Размер текста кнопки */
      height: 19px;
      padding: 22px 20px;
      border-radius: 8px;
      margin: 0 auto;
      margin-top: 50px;
    }

    &__compass {
      position: absolute;
      width: 223px;
      height: auto;
      z-index: 1;
    }

    &__cloud {
      width: 267px;
      height: auto;
      flex-shrink: 0;
      top: 20%;
      z-index: 0;
      opacity: 0.8;
      &.cloud-left {
        left: -10%;
      }

      &.cloud-right {
        right: -10%;
      }
    }
  }
}
@media (max-width: 768px) {
  .not-found {
    padding: 20px;
    height: auto;
    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 40px;
      &-img {
        height: auto;
        display: flex;
      }
    }

    h1 {
      font-size: 80px;
    }

    &__title {
      font-size: 20px;
    }

    &__subtitle {
      font-size: 14px;
      margin-bottom: 0;
    }

    &__button {
      font-size: 16px;
      height: 19px;
      padding: 22px 20px;
      border-radius: 8px;
      margin: 0 auto;
    }

    &__compass {
      width: 164px;
      height: 164px;
      position: static;
      margin: 0 auto;
      margin-bottom: 120px;
    }

    &__cloud {
      width: 150px;
      height: auto;
      opacity: 0.6;

      &.cloud-left {
        top: -50px;
        left: -20px;
      }

      &.cloud-right {
        top: -50px;
        right: -20px;
      }
    }
  }
}
</style>
